/*
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview Composant générique de drop down
 */
(function($, $g) {
    var $document = $(document);
    var OPEN_BLOCK_DELAY = 300;

    function time() {
        return new Date().getTime();
    }

    function Dropdown($btn, $target, openClass) {
        var me = this;
        var opened = false;
        var $all = $btn.add($target);
        openClass=openClass||"active";

        function documentClick() {
            setTimeout(function() {
                if (opened) {
                    me.close();
                }
            },1);
        }

        /**
         * Ouvertude du dropdown
         * @returns {undefined}
         */
        this.open = function(options) {
            var options = options || {};
            var now = time();
            if (now>Dropdown.noOpenBefore||options.force) {
                Dropdown.closeAll();            
                Dropdown.opened.push(me);
                $all.addClass(openClass);
                opened=true;
                if (!options.dontClose) {
                    $document.on("click touchend",documentClick);
                }
            }
        };

        /**
         * Fermeture du dropdown
         * @returns {undefined}
         */
        this.close = function() {
            var index = Dropdown.opened.indexOf(me);
            if (index>=0) {
                Dropdown.opened.splice(index, 1);
            }            
            $all.removeClass(openClass);
            opened=false;
            $document.off("click touchend", documentClick);
            Dropdown.noOpenBefore=time()+OPEN_BLOCK_DELAY;
        };

        /**
         * Basculer d'un état à l'autre
         * @returns {undefined}
         */
        this.toggle = function() {
            if (opened) {
                me.close();
            } else {
                me.open();
            }
            return false;
        };

        /**
         * Attaché les événements
         * @returns {undefined}
         */
        this.attach = function() {
            $btn.click(me.toggle);
            $target.on("click touchend", function(e) {
                e.stopPropagation();
            });
            $target.find(".action-dropdown-close").click(function() {
               me.close();
            });
        };
    }

    Dropdown.register = function(sel, openClass) {
        $g.behavior.add(sel, function() {
            var $me = $(this);
            var target = $me.data("target");
            var $target = $(target);
            var drop = new Dropdown($me, $target, openClass);
            drop.attach();
            $me.data("dropdown", drop);
        });
    };
    
    Dropdown.closeAll = function() {
        while (Dropdown.opened.length > 0) {
            Dropdown.opened[0].close();
        }
    };

    Dropdown.opened = [];
    Dropdown.noOpenBefore = 0;
    Dropdown.register(".action-dropdown");

    $g.Dropdown = Dropdown;
    module.exports = Dropdown;
})(jQuery, PVPGEngine);